import FunctionButton from "components/common/FuncButton";
import Slider from "components/common/Slider";
import { useGuideContext } from "pages/project/editor/guide/Guide";
import { useHttpContext, useHttpUtil } from "context/HttpContext";
import { usePermissionContext } from "context/Permission";
import { createContext, useContext, useEffect, useState } from "react";
import { useDetailContext } from "../DetailContext";
import { ActionName, EventCallbackParamsType, MockupObject } from "../MockupEditor";
import Stats from "libs/utils/stats";
import ElementTips from "../guide/ElementTips";
import CustomImage from "components/common/CustomImage";
import { useMockupsContext } from "pages/project/mockups/MockupsContext";

interface FunctionBtnObj {
    currentOperateElement: OperateElement | undefined,
    setCurrentOperateElement: (element: OperateElement | undefined) => void,
    penSize: number,
    penChangeHandler: (size: number) => void,
    penEditType: number,
    changePenEditType: (type: number) => void,
    cancelPen: () => void
  }
  export const FunctionBtnContext = createContext<FunctionBtnObj|null>(null);
  
  export function useFunctionBtnContext() : FunctionBtnObj | null{
    return useContext(FunctionBtnContext);
  }
  

export default function EditorFunctionBtns(){
    // 当前正在操作的对象,其他功能按钮将禁用(当前有:Mockup, AI消除进行中, 去除背景, 智能换色)
    const [ currentOperateElement, setCurrentOperateElement ] = useState<OperateElement>();

    const detailContext = useDetailContext();
    const guideContext = useGuideContext();

    const [penSize, setPenSize] = useState<number>(5);
    
    // 画笔类型
    const [penEditType, setPenEditType] = useState<number>(0);

    
    // 设置画笔大小
    const penChangeHandler = (size: number) => {
        detailContext?.triggerEditorAction({
            name: ActionName.SETTING_PEN_SIZE,
            params: `${size}`
        })
    }

    // 设置画笔类型
    const changePenEditType = (type: number) => {
        setPenEditType(type);
    }

    // 取消画笔
    const cancelPen = () => {
        if(penEditType == 0) return ;
        detailContext?.triggerEditorAction({
            name: ActionName.VECTOR_AI_ERASE_CLOSE,
        })
        changePenEditType(0);
        setCurrentOperateElement(undefined);
    }

    useEffect(() => {
        cancelPen();
    },[detailContext?.checkedElementData?.type])

    useEffect(() => {
        let actionName : ActionName | null = null  ;
        if(detailContext?.checkedElementData?.type == 2){ // 向量图的画笔
            if(penEditType == 1){
                actionName = ActionName.VECTOR_AI_ERASE_MAN_START
            }else if(penEditType == 2){
                actionName = ActionName.VECTOR_AI_ERASE_CIRCLE_START
            }
        }
        // else if(detailContext?.checkedElementData?.type == 1){ // 底图的画笔
        //     if(penEditType == 1){
        //         actionName = ActionName.MOCKUP_AREA_START
        //         Stats.google('Area sel Daub')
        //     }else if(penEditType == 2){
        //         actionName = ActionName.MOCKUP_AI_AREA_START
        //         Stats.google('Area sel Smart click')
        //     }
        // }
        if(actionName){
            detailContext?.triggerEditorAction({
                name: actionName
            })
            detailContext?.checkedElementData && setCurrentOperateElement({
                type: actionName,
                element: detailContext.checkedElementData,
                status: OperateStatus.START
            })
        }
        
    },[penEditType])

    useEffect(() => {  
        disponseCallbackData();
    },[detailContext?.editorCallbackData])

    // 处理相关的回调
    const disponseCallbackData = async () => {
        const type = detailContext?.editorCallbackData?.type ;
        switch(type){
            case EventCallbackParamsType.GET_PEN_SIZE_CALLBACK: // 获取画笔大小
                setPenSize(+detailContext?.editorCallbackData?.data);
                break;
            case EventCallbackParamsType.ACTION_FINISH: // Action执行完成
            case EventCallbackParamsType.ERASE_DRAW_EXIT_CALLBACK: // 智能选区 | 智能换色 完成(取消或生效)时会触发
                setCurrentOperateElement(undefined);
                break;
            // case EventCallbackParamsType.EDITOR_NEW_OBJECT_CALLBACK: // 新添加对象
            //     console.info('editor function btns EDITOR_NEW_OBJECT_CALLBACK')
            //     cancelPen();
            //     break ;
        }
    }

    useEffect(() => {  
        const type = detailContext?.editorAction?.name;
        switch(type){
            case ActionName.LOADING_IMAGE:
                cancelPen();
                break;
        }
    },[detailContext?.editorAction])


    return (
        <FunctionBtnContext.Provider value={{
            currentOperateElement, setCurrentOperateElement, penSize, penChangeHandler, penEditType, changePenEditType, cancelPen
        }}>
            {
                (!detailContext?.checkedElementData || detailContext?.checkedElementData?.type == 2 || guideContext?.isStartGuide 
                    || (detailContext?.checkedElementData?.type == 1 
                        && detailContext?.checkedElementData?.uuid === currentOperateElement?.element.uuid 
                        && currentOperateElement?.type == ActionName.MOCKUP))
                    && <ImageFunctionBtns />
            }
            {
                (detailContext?.checkedElementData?.type == 1 
                    && (!currentOperateElement || !(currentOperateElement?.type == ActionName.MOCKUP 
                        && detailContext?.checkedElementData?.uuid === currentOperateElement?.element.uuid)))
                && <ModelFunctionbtns />
            }
            {
                (detailContext?.checkedElementData?.type == 3 
                    && (!currentOperateElement || !(currentOperateElement?.type == ActionName.MOCKUP 
                        && detailContext?.checkedElementData?.uuid === currentOperateElement?.element.uuid)))
                && <TextFunctionbtns />
            }
            <PenControl />
            {
                // detailContext?.checkedElementData?.type == 1 && penEditType == 2 && 
                //     <ElementTips title="Please click on the area where you want to display the design." 
                //         gif="/case/icon-mockup-area.gif" type="select-area"/>
            }
        </FunctionBtnContext.Provider>
    )
}

// 向量图的操作按钮
function ImageFunctionBtns(){
    const detailContext = useDetailContext();
    const functionBtnContext = useFunctionBtnContext();
    const mockupsContext = useMockupsContext();
    const httpUtil = useHttpUtil();
    const httpContent = useHttpContext();
    const permissionContext = usePermissionContext();

    // 添加时高亮提示
    const  [ addLightTip, setAddLightTip ] = useState<number>(0);

    // // 编辑器选择图片时的工具栏模式1-4
    // const [imageEditType, setImageEditType] = useState<number>(0);

    // 选中编辑器图片时的功能模式
    const selectedImageEditMode = async (type : number) => {
        if(mockupsContext?.isMockups && !mockupsContext.mockupsDetail?.isLogin) return mockupsContext.showLogin();
        if(!detailContext?.checkedElementData){
            return httpContent?.response(100, 'Please select an image on the canvas to proceed (or upload one).');
        }
        if(type == 1){ // 转模型
            // 设置
            detailContext?.checkedElementData && functionBtnContext?.setCurrentOperateElement({
                type: ActionName.MOCKUP,
                element: detailContext.checkedElementData,
                status: OperateStatus.PROCESSING
            })
            const resData = await httpUtil.post('/biz/func/mockup',{
                projectId: detailContext?.project.projectId
            })
            if(!resData.errCode){
                detailContext?.triggerEditorAction({
                    name: ActionName.MOCKUP,
                    params: `${detailContext?.checkedElementData?.uuid}`
                })

                permissionContext?.updator();
            }else{
                functionBtnContext?.setCurrentOperateElement(undefined);
            }

            Stats.google('Mockup');
        }else if(type == 3){ // 去除背景
            if(detailContext?.checkedElementData){
                // 设置
                detailContext?.checkedElementData && functionBtnContext?.setCurrentOperateElement({
                    type: ActionName.VECTOR_REMOVE_BACKGROUD,
                    element: detailContext?.checkedElementData,
                    status: OperateStatus.PROCESSING
                })

                detailContext?.setImageEditType(type);
                setTimeout(() => {
                    detailContext?.triggerEditorAction({
                        name: ActionName.VECTOR_REMOVE_BACKGROUD,
                    })
                }, 50);
            }
        }else if(type == 5){ // 转高清
            if(detailContext?.checkedElementData && detailContext?.checkedElementData.mImageUrl){
                // 设置
                detailContext?.checkedElementData && functionBtnContext?.setCurrentOperateElement({
                    type: ActionName.VECTOR_HD_UPSCALE,
                    element: detailContext?.checkedElementData,
                    status: OperateStatus.PROCESSING
                })

                detailContext?.setImageEditType(type);

                setTimeout(() => {
                    detailContext?.triggerEditorAction({
                        name: ActionName.VECTOR_HD_UPSCALE,
                    })
                }, 50);

                
                setTimeout(() => {
                    detailContext?.triggerEditorAction({
                        name: ActionName.IMAGE_SHOW_LOADING,
                        params: detailContext?.checkedElementData?.uuid
                    })
                }, 20);
                Stats.google('Clarity');
            }
        }else { 
            type = detailContext?.imageEditType == type ? 0 : type ;
            if(detailContext?.imageEditType == 2 && type == 0){ // 画笔取消
                functionBtnContext?.cancelPen();
            }else if(detailContext?.imageEditType == 4 && type == 0){  // 退出智能换色
                detailContext?.triggerEditorAction({
                    name: ActionName.VECTOR_AI_ERASE_CLOSE,
                })
            }
            if(type == 2) Stats.google('Erase');
            else if(type == 4)  Stats.google('Color');
        } 
      
        detailContext?.setImageEditType(type);
    }

    useEffect(() => {
        if(functionBtnContext?.penEditType == 0){
            detailContext?.setImageEditType(0);
        }
    }, [ functionBtnContext?.penEditType ])

    useEffect(() => {  
        disponseCallbackData();
    },[detailContext?.editorCallbackData])

    // 处理相关的回调
    const disponseCallbackData = async () => {
        const projectId = detailContext?.project.projectId as string;
        const type = detailContext?.editorCallbackData?.type ;
        const data = detailContext?.editorCallbackData?.data ;
        switch(type){
            case EventCallbackParamsType.ADD_ELEMENT_SUC_CALLBACK: // 添加图像成功
                setAddLightTip((n: number) => ++n);
                break;
            case EventCallbackParamsType.VECTOR_REMOVE_BACKGROUD_CALLBACK: // 去除背景之后的回调
                const rgbResData = await httpUtil.post('/biz/func/remove/background',{
                    srcImage: data,
                    projectId
                });

                functionBtnContext?.setCurrentOperateElement(undefined);
                permissionContext?.updator();

                if(!rgbResData.errCode){
                    httpContent?.response(0, 'Background successfully removed')
                    detailContext?.triggerEditorAction({
                        name: ActionName.REPLACE_IMAGE,
                        params : rgbResData.data
                    })

                    Stats.google('Remove Background');
                }else{
                    detailContext?.triggerEditorAction({
                        name: ActionName.IMAGE_HIDDEN_LOADING,
                        params: detailContext?.checkedElementData?.uuid
                    })
                }
                detailContext?.setImageEditType(0);
                break;
            case EventCallbackParamsType.VECTOR_HD_UPSCALE_CALLBACK: // 转高清之后的回调
                const hdResData = await httpUtil.post('/biz/func/hd',{
                    srcImage: data,
                    projectId
                })
                functionBtnContext?.setCurrentOperateElement(undefined);
                permissionContext?.updator();
                
                if(!hdResData.errCode){
                    httpContent?.response(0, 'Clarity improved')
                    detailContext?.triggerEditorAction({
                        name: ActionName.REPLACE_IMAGE,
                        params : hdResData.data
                    })
                }else{
                    detailContext?.triggerEditorAction({
                        name: ActionName.IMAGE_HIDDEN_LOADING,
                        params: detailContext?.checkedElementData?.uuid
                    })
                }
                detailContext?.setImageEditType(0);
                break;
            case EventCallbackParamsType.ERASE_DRAW_EXIT_CALLBACK: // 画笔退出后的回调
                detailContext?.setImageEditType(0);
                break;
        }
    }

    return (
        <div className="flex gap-[5px]" 
            // id="step3_element"
            >
            <FunctionButton id="step2_element" title="Mockup" isActive={false} lightShow={addLightTip}
                isLoading={functionBtnContext?.currentOperateElement?.type == ActionName.MOCKUP && functionBtnContext?.currentOperateElement?.status == OperateStatus.PROCESSING} 
                isDisabled={detailContext?.isSelectedMore || functionBtnContext?.currentOperateElement && functionBtnContext?.currentOperateElement.type != ActionName.MOCKUP || detailContext?.imageEditType == 4}
                iconPath="/icon/icon-editor-mockup.png" onClick={() => selectedImageEditMode(1)} 
                bubble={{ title: 'Mockup', videoId: '8XeqLTUrDWA', desc: 'Use the selected layer as a mockup image. Drag it to the mockup base and it will stretch to fit the surface.'}} />
                
            <FunctionButton isActive={detailContext?.imageEditType == 4} title="Color"
                isDisabled={detailContext?.isSelectedMore || !!functionBtnContext?.currentOperateElement}
                iconPath="/icon/icon-editor-model-color.png" onClick={() => selectedImageEditMode(4)} 
                bubble={{ title: 'Smart color change', videoId: '_ymf7vRYdjs', desc: 'Switch product model colors.'}} />
            <FunctionButton isActive={false} title="Remove bg"
                isLoading={functionBtnContext?.currentOperateElement?.type == ActionName.VECTOR_REMOVE_BACKGROUD && functionBtnContext?.currentOperateElement?.status == OperateStatus.PROCESSING} 
                isDisabled={detailContext?.isSelectedMore || functionBtnContext?.currentOperateElement && functionBtnContext?.currentOperateElement.type != ActionName.VECTOR_REMOVE_BACKGROUD || detailContext?.imageEditType == 4}
                iconPath="/icon/icon-editor-nobg.png" onClick={() => selectedImageEditMode(3)} 
                bubble={{ title: 'Remove background', videoId: 'pGVTpWKn6OA', desc: 'One click removal of background.'}} />
            <FunctionButton isActive={detailContext?.imageEditType == 2} title="Erase" iconPath="/icon/icon-editor-pen.png" onClick={() => selectedImageEditMode(2)}
                isDisabled={detailContext?.isSelectedMore || functionBtnContext?.currentOperateElement !== undefined 
                    && (functionBtnContext?.currentOperateElement.type != ActionName.VECTOR_AI_ERASE_MAN_START 
                        && functionBtnContext?.currentOperateElement.type != ActionName.VECTOR_AI_ERASE_CIRCLE_START) || detailContext?.imageEditType == 4}
                bubble={{ title: 'Intelligent elimination', videoId: 'uzTKlLUOt8U', desc: 'Remove unwanted elements.'}} >
                {
                    detailContext?.imageEditType == 2 && functionBtnContext?.penEditType != 2 && 
                    <div className="absolute top-[47px] left-[-65px] flex flex-col w-[210px] border rounded-[5px] bg-[#FFFFFF] z-[1201] text-[14px] font-bold text-[#000000] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)]">
                        {
                            functionBtnContext?.penEditType == 0 ?
                            <>
                                <div className="flex items-center gap-[10px] py-[8px] pl-[15px] hover:bg-[#D9F2FF]"
                                    onClick={(e) => {functionBtnContext?.changePenEditType(1); e.stopPropagation();}}>
                                    <CustomImage src="/icon/icon-editor-image-pen-daub.png" className="w-[23px]" />
                                    <span className="">Daub</span>
                                </div>
                                <div className="flex items-center gap-[10px] py-[8px] pl-[15px] hover:bg-[#D9F2FF]"
                                    onClick={(e) => {functionBtnContext?.changePenEditType(2); e.stopPropagation();}}>
                                    <CustomImage src="/icon/icon-editor-image-pen-circle.png" className="w-[23px]" />
                                    <span>Circle Select</span>
                                </div>
                            </>
                            :
                            functionBtnContext?.penEditType == 1 && 
                            <div className="flex items-center gap-[10px] py-[4px] px-[15px] hover:bg-[#D9F2FF]"
                                onClick={(e) => e.stopPropagation()}>
                                <span>Brush size</span>
                                <Slider init={functionBtnContext?.penSize || 5} changeHandler={functionBtnContext?.penChangeHandler as Function} />
                            </div>
                        }

                        {
                            // penEditType == 1 && 
                            // <div className="absolute w-[210px] left-[230px] top-[0px] bg-[#FFFFFF] px-[12px] py-[9px] flex items-center gap-[10px] rounded-[5px] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)]"
                            //     onClick={(e) => e.stopPropagation()}>
                            //     <span>Brush size</span>
                            //     <Slider init={penSize} changeHandler={penChangeHandler} />
                            // </div>
                        }
                    </div>
                }
            </FunctionButton>
            <FunctionButton isActive={false}  title="Clarity"
                iconPath="/icon/icon-editor-hd.png" onClick={() => selectedImageEditMode(5)} 
                isLoading={functionBtnContext?.currentOperateElement?.type == ActionName.VECTOR_HD_UPSCALE && functionBtnContext?.currentOperateElement?.status == OperateStatus.PROCESSING} 
                isDisabled={detailContext?.isSelectedMore || functionBtnContext?.currentOperateElement && functionBtnContext?.currentOperateElement.type != ActionName.VECTOR_HD_UPSCALE || detailContext?.imageEditType == 4}
                bubble={{ title: 'Improve clarity', desc: 'Increases image resolution, making it sharper and cleaner.'}} />
        </div>
    )
}

// 底图的操作按钮
function ModelFunctionbtns(){
    const detailContext = useDetailContext();
    const functionBtnContext = useFunctionBtnContext();
    const mockupsContext = useMockupsContext();

     // 画笔模式(涂抹-1 / 擦除-2)
    //  const [penEditModel, setPenEditModel] = useState<number>(0);

     // 选中编辑器模型时的功能模式
    const selectedModelEditMode = (type : number) => {
        if(mockupsContext?.isMockups && !mockupsContext.mockupsDetail?.isLogin) return mockupsContext.showLogin();
        if(type == 2){ // 栅格化，转图片
            Stats.google('Rasterize');
            detailContext?.checkedElementData && functionBtnContext?.setCurrentOperateElement({
                type: ActionName.VECTOR,
                element: detailContext?.checkedElementData,
                status: OperateStatus.PROCESSING
            })

            setTimeout(() => {
                detailContext?.triggerEditorAction({
                    name: ActionName.VECTOR
                })
            }, 20)
            return ;
        }else if(type == 1){
            // Stats.google('Area select');
            detailContext?.checkedElementData && functionBtnContext?.setCurrentOperateElement({
                type: ActionName.MOCKUP_AREA_START,
                element: detailContext?.checkedElementData,
                status: OperateStatus.PROCESSING
            })
        }
        type = detailContext?.modelEditType == type ? 0 : type ;
        if(detailContext?.modelEditType == 1 && type == 0){ // 画笔取消
            functionBtnContext?.cancelPen();
        }
        detailContext?.setModelEditType(type);
    }

    // 底图切换模式，涂抹|擦除
    // const switchMockupEditModel = (type: number) => {
    //     detailContext?.triggerEditorAction({
    //         name: ActionName.MOCKUP_PEN_SWITCH,
    //         params : type == 1 ? '1' : '0'
    //     })
    //     setPenEditModel(type);
    // }

    // useEffect(() => {
    //     if(functionBtnContext?.penEditType == 0){
    //         detailContext?.setModelEditType(0);
    //         setPenEditModel(0);
    //     }else {
    //         setPenEditModel(1);
    //     }
    // }, [ functionBtnContext?.penEditType ])
    
    // useEffect(() => {  
    //     disponseCallbackData();
    // },[detailContext?.editorCallbackData])

    // // 处理相关的回调
    // const disponseCallbackData = async () => {
    //     const type = detailContext?.editorCallbackData?.type ;
    //     const data = detailContext?.editorCallbackData?.data ;
    //     switch(type){
    //         case EventCallbackParamsType.MOCKUP_TO_VECTOR_CALLBACK: // 底图转向量图后的回调
    //             functionBtnContext?.setCurrentOperateElement(undefined);
    //             detailContext?.setCheckedElementData({...(data as MockupObject)})
    //             break;
    //     }
    // }

    return (
        <div className="flex gap-[5px]">
            <FunctionButton isActive={detailContext?.modelEditType == 1} title="Area sel" iconPath="/icon/icon-editor-model-pen.png" onClick={() => {selectedModelEditMode(1); functionBtnContext?.changePenEditType(0)}}
                isDisabled={functionBtnContext?.currentOperateElement &&  (functionBtnContext?.currentOperateElement.type != ActionName.MOCKUP_AREA_START 
                    && functionBtnContext?.currentOperateElement.type != ActionName.MOCKUP_AI_AREA_START)}
                bubble={{ title: 'Area selection', videoId: 'nNO1OYVtAx8', desc: 'Use Brush draw or Smart Click to select areas where patterns can be placed on the mockup.'}} >
                {/* {
                    detailContext?.modelEditType == 1 && functionBtnContext?.penEditType != 2 && 
                    <div className="absolute top-[47px] left-[-45px] flex flex-col w-[210px] border rounded-[5px] bg-[#FFFFFF] z-[1201] text-[14px] font-bold text-[#000000] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)]">
                        {
                            functionBtnContext?.penEditType == 0 ?
                            <>
                                <div className="flex items-center gap-[10px] py-[8px] pl-[15px] hover:bg-[#D9F2FF]"
                                    onClick={(e) => {functionBtnContext?.changePenEditType(1); e.stopPropagation();}}>
                                    <CustomImage src="/icon/icon-editor-image-pen-daub.png" className="w-[23px]" />
                                    <span className="">Daub</span>
                                </div>
                                <div className="flex items-center gap-[10px] py-[8px] pl-[15px] hover:bg-[#D9F2FF]"
                                    onClick={(e) => {functionBtnContext?.changePenEditType(2); e.stopPropagation();}}>
                                    <CustomImage src="/icon/icon-editor-pen-smart-click.png" className="w-[23px]" />
                                    <span>Smart click</span>
                                </div>
                            </>
                            :
                            <div className="flex items-center gap-[10px] py-[4px] px-[15px]"
                                onClick={(e) => e.stopPropagation()}>
                                <div className="p-[3px] rounded-[5px]"
                                    style={{
                                        ...(penEditModel === 1 ? { backgroundColor: '#D9F2FF'} : {})
                                    }}
                                    onClick={() => switchMockupEditModel(1)}><CustomImage src="/icon/icon-mockup-pen-1.png" className="w-[25px] h-[25px]"/></div>
                                {
                                    functionBtnContext?.penEditType === 1 && 
                                    <div className="p-[3px] rounded-[5px]"
                                        style={{
                                            ...(penEditModel === 2 ? { backgroundColor: '#D9F2FF'} : {})
                                        }}
                                        onClick={() => switchMockupEditModel(2)}><CustomImage src="/icon/icon-mockup-pen-2.png" className="w-[25px] h-[25px]"/></div>
                                }
                                <Slider init={functionBtnContext?.penSize || 5} changeHandler={functionBtnContext?.penChangeHandler as Function} />
                            </div>
                        }
                    </div>
                } */}
            </FunctionButton>
            <FunctionButton isActive={false} title="Rasterize" iconPath={"/icon/icon-editor-model-frame.png"} onClick={() => selectedModelEditMode(2)} 
                isLoading={functionBtnContext?.currentOperateElement?.type == ActionName.VECTOR && functionBtnContext?.currentOperateElement?.status == OperateStatus.PROCESSING} 
                isDisabled={functionBtnContext?.currentOperateElement && functionBtnContext?.currentOperateElement.type != ActionName.VECTOR}
                bubble={{ title: 'Rasterizing', desc: 'Convert the mockup with all its attached layers into a raster image.'}} />
        </div>
    )
}

// 文本的操作按钮
function TextFunctionbtns(){
    const detailContext = useDetailContext();
    const functionBtnContext = useFunctionBtnContext();

    // 编辑器选择图片时的工具栏模式1-3
    // const [modelEditType, setModelEditType] = useState<number>(0);

     // 选中编辑器模型时的功能模式
    const selectedModelEditMode = (type : number) => {
        if(type == 1){ // 栅格化，转图片
            Stats.google('Flatten text');
            detailContext?.checkedElementData && functionBtnContext?.setCurrentOperateElement({
                type: ActionName.TEXT_TO_IMAGE,
                element: detailContext?.checkedElementData,
                status: OperateStatus.PROCESSING
            })

            setTimeout(() => {
                detailContext?.triggerEditorAction({
                    name: ActionName.TEXT_TO_IMAGE
                })
            }, 10)
            return ;
        }
        // setModelEditType(type);
    }

    useEffect(() => {  
        disponseCallbackData();
    },[detailContext?.editorCallbackData])

    // 处理相关的回调
    const disponseCallbackData = async () => {
        const type = detailContext?.editorCallbackData?.type ;
        const data = detailContext?.editorCallbackData?.data ;
        switch(type){
            case EventCallbackParamsType.TEXT_TO_IMAGE_CALLBACK: // 文字转向量图后的回调
                functionBtnContext?.setCurrentOperateElement(undefined);
                detailContext?.setCheckedElementData({...(data as MockupObject)})
                break;
        }
    }

    return (
        <div className="flex gap-[5px]">
            <FunctionButton isActive={false} title="Flatten text" iconPath={"/icon/icon-model-text-2-img.png"} onClick={() => selectedModelEditMode(1)} 
                isLoading={functionBtnContext?.currentOperateElement?.type == ActionName.TEXT_TO_IMAGE && functionBtnContext?.currentOperateElement?.status == OperateStatus.PROCESSING} 
                isDisabled={functionBtnContext?.currentOperateElement && functionBtnContext?.currentOperateElement.type != ActionName.TEXT_TO_IMAGE}
                bubble={{ title: 'Flatten text', desc: 'Convert text to image for easy application onto mockups.'}} />
        </div>
    )
}

// 画笔控制区域(取消/确认)
function PenControl(){
    const permissionContext = usePermissionContext();
    const detailContext = useDetailContext();
    const httpUtil = useHttpUtil();
    const functionBtnContext = useFunctionBtnContext();
    // 是否正在确认画笔区域(AI消除-向量图 与 区域选择-底图)
    const [isConfirmPen, setIsConfirmPen] = useState<boolean>(false);

    // 确认画笔
    const confirmPen = async () => {
        if(isConfirmPen) return ;

        if(detailContext?.checkedElementData?.type == 2){
            const resData = await httpUtil.post('/biz/func/ai/erase',{
                projectId: detailContext?.project.projectId
            })
            if(resData.errCode) return ;
            permissionContext?.updator();
        }

        setIsConfirmPen(true);
        const name = detailContext?.checkedElementData?.type == 2 ? ActionName.VECTOR_AI_ERASE_CLEAR : 
            functionBtnContext?.penEditType == 1 ? ActionName.MOCKUP_CONFIRM : ActionName.MOCKUP_AI_CONFIRM ;
        setTimeout(() => {
            detailContext?.triggerEditorAction({
                name
            })
        },10)
        
    }

    useEffect(() => {  
        disponseCallbackData();
    },[detailContext?.editorCallbackData])

    // 处理相关的回调
    const disponseCallbackData = async () => {
        const type = detailContext?.editorCallbackData?.type ;
        switch(type){
            case EventCallbackParamsType.PEN_CONFIRM_CALLBACK: //  画笔确认。 AI消除成功后的回调(向量图) | 确认区域画笔成功后的回调(底图)
                functionBtnContext?.cancelPen();
                setIsConfirmPen(false);
                break;
        }
    }

    return (
        <>
            {
                functionBtnContext && functionBtnContext?.penEditType > 0 &&
                <div className="absolute bottom-[10px] xl:bottom-[20px] left-[50%] translate-x-[-50%] flex items-center gap-[10px] z-[1202]">
                    <div className="bg-[#D9D9D9] p-[8px] rounded-[10px] cursor-pointer"
                        onClick={() => functionBtnContext?.cancelPen()}><CustomImage src="/icon/icon-cancel.png" className="w-[26px] h-[26px] xl:w-[34px] xl:h-[34px] "/></div>
                    <div className="bg-[#14A5FA] p-[8px] rounded-[10px] cursor-pointer "
                        onClick={confirmPen}>
                        {
                            isConfirmPen ?
                            <p className="animate-spin">
                                <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4287" className="w-[26px] h-[26px] xl:w-[34px] xl:h-[34px]" ><path d="M96 512c0-19.33 15.67-35 35-35s35 15.67 35 35c0 191.09 154.91 346 346 346s346-154.91 346-346-154.91-346-346-346c-19.33 0-35-15.67-35-35s15.67-35 35-35c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512z" fill="#10F28D" p-id="4288"></path></svg>
                            </p>
                            :
                            <CustomImage src="/icon/icon-confirm.png" className="w-[26px] h-[26px] xl:w-[34px] xl:h-[34px]"/>
                        }
                    </div>
                </div>
            }
        </>
    )
}


enum OperateStatus {
    START,
    PROCESSING,
    FINISH
}

type OperateElement = {
    type : ActionName,
    element : MockupObject,
    status : OperateStatus
}